<div class="d-flex justify-content-center">
    <div style="width: 400px;">
        <div class="card card-border-color card-border-color-primary p-shadow-8" *ngIf="ooVenue">
            <div class="card-header text-center  flex-column">
                <img class="w-100"
                    [src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/logo.png'"
                    onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/logo.png'" />
                <div class="disclaimer" 
                    [style.background-color]="ooVenue.styles?.headerBgColor"
                    [style.color]="ooVenue.styles?.headerTextColor">
                    <div *ngIf="!unsubscribed" style="max-width: 1200px;" class="d-flex flex-column h-100 align-items-center mx-auto mt-4">
                        <div>
                            We're sorry to see you go!. Please click the button below to confirm your unsubscription request for {{customerEmail}}:
                        </div>
                        <p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="confirmUnsubscribe()">
                            <ng-template pTemplate="content">
                                Unsubscribe Me!
                            </ng-template>
                        </p-button>
                        <div>
                            You will continue to receive order confirmations & receipts from us when you place an order or request a receipt.
                        </div>
                    </div>
                    <div *ngIf="unsubscribed" style="max-width: 1200px;" class="d-flex flex-column h-100 align-items-center mx-auto mt-5">
                        <div>
                            {{customerEmail}} has been unsubscribed.
                        </div>
                        <div>
                            You will continue to receive order confirmations & receipts from us when you place an order or request a
                            receipt.
                        </div>
                    </div>
                </div>
            </div>

            <app-venue-info-footer *ngIf="ooVenue" [ooVenue]="ooVenue"></app-venue-info-footer>
        </div>
    </div>
</div>